import { render } from "./BehalfRegistrationLagos.vue?vue&type=template&id=6b9b2762&scoped=true"
import script from "./BehalfRegistrationLagos.vue?vue&type=script&lang=js"
export * from "./BehalfRegistrationLagos.vue?vue&type=script&lang=js"

import "./BehalfRegistrationLagos.vue?vue&type=style&index=0&id=6b9b2762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9b2762"]])

export default __exports__